export const  ACTION_SAVE = "SAVE";
export const  ACTION_EDIT = "EDIT";
export const  ACTION_TRANSFER = "TRANSFER";
export const  ACTION_DELETE = "DELETE";
export const  ACTION_DELETE_EMPLOYMENT_RELATIONSHIP = "DELETE_EMPLOYMENT_RELATIONSHIP";
export const  MEMBERS = "MEMBERS";
export const  RESPONSABLES = "RESPONSABLES";
export const  PHYSICAL_ENTITY = "PHYSICAL_ENTITY";